import SimpleParallax from "simple-parallax-js/vanilla";

var image = document.getElementsByClassName('mainvisual');
new SimpleParallax(image, {
    delay: 0,
    scale: 1.3,
});
